<template>
  <div class="StorySlider">
    <div>
        <div class="c-section">
            <div class="c-products-row items" dir="ltr" ref="slider" @mousedown="mousedown" @mouseup="mouseup" @mousemove="mousemove" @mouseleave="handleMouseLeave">
              <template v-if="story_list">
                <div class="c-item" :key="obj" v-for="obj in story_list">
                    <StoryView :obj="obj" />
                </div>
              </template>
              <template v-if="!story_list">
                <div class="c-item" :key="obj" v-for="obj in 12">
                    <StoryView :obj="null" />
                </div>
              </template>
            </div>
        </div>
        <template v-if="story_list">
          <template :key="obj" v-for="obj in story_list">
            <StoryModal :obj="obj" />
          </template>
        </template>
    </div>
  </div>
</template>

<script>
import StoryView from '@/components/StoryView.vue'
import StoryModal from '@/components/StoryModal.vue'

export default {
  name: 'StorySlider',
  data () {
    return {
      isDown: false,
      startX: null,
      scrollLeft: null,
      story_list: []
    }
  },
  components: {
    StoryView,
    StoryModal
  },
  props: {
    stories: Array
  },
  methods: {
    mousedown: function (e) {
      this.isDown = true
      this.$refs.slider.classList.add('active')
      this.startX = e.pageX - this.$refs.slider.offsetLeft
      this.scrollLeft = this.$refs.slider.scrollLeft
    },
    mouseup: function () {
      this.isDown = false
      this.$refs.slider.classList.remove('active')
    },
    mousemove: function (e) {
      if (this.isDown) {
        e.preventDefault()
        const x = e.pageX - this.$refs.slider.offsetLeft
        const walk = (x - this.startX) * 2
        this.$refs.slider.scrollLeft = this.scrollLeft - walk
      }
    },
    handleMouseLeave: function () {
      if (this.isDown) {
        this.isDown = false
        this.$refs.slider.classList.remove('active')
      }
    },
    sort_stories: function () {
      if (this.story_list) {
        const seenItems = localStorage.getItem('seen') ? JSON.parse(localStorage.getItem('seen')) : []
        this.story_list = this.story_list.sort((a, b) => {
          const aSeen = seenItems.includes(a.id)
          const bSeen = seenItems.includes(b.id)
          return aSeen - bSeen
        })
      }
    }
  },
  mounted () {
    this.story_list = this.stories
    this.sort_stories()
  },
  watch: {
    stories: {
      handler () {
        this.story_list = this.stories
        this.sort_stories()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.items {
  position: relative;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: all 0.2s;
  transform: scale(0.97);
  will-change: transform;
  user-select: none;
  cursor: pointer;
  scrollbar-width: none;
}

.items.active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
  transform: scale(1);
}

</style>
